import BaseLevelScene from './BaseLevelScene';

export default class HouseScene extends BaseLevelScene {
  tileWidth: integer = 16;
  tileHeight: integer = 16;
  name: string;
  tileMapName: string;
  tileMapPath: string;
  readyToRefresh: boolean = false;
  constructor(name: string, tilemapName:string, tileMapPath: string) {
    super(name);
    this.name = name;
    this.tileMapName = tilemapName;
    this.tileMapPath = tileMapPath;
  }

  preload() {

    // Preload base level
    this.preloadBaseLevel();

    // load the PNG files
    this.load.image('house_tiles', 'assets/sourceImages/HouseInterrior.png');
    this.load.image('bed_tiles', 'assets/sourceImages/asakuraki_beds_16X16.png');

    // load the JSON map
    this.load.tilemapTiledJSON(
      this.tileMapName,
      this.tileMapPath
    );
  }

  create() {
    // create the Tilemap
    this.map = this.make.tilemap({ key: this.tileMapName });

    // add the tileset image we are using (note name must match tileset in map)
    const houseTileset = this.map.addTilesetImage('HouseInterrior', 'house_tiles');
    const bedsTileset = this.map.addTilesetImage('beds', 'bed_tiles');

    const allLayers = [houseTileset, bedsTileset];

    // // create the layers we want in the right order
    const base = this.map.createLayer('Base', allLayers);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(base);

    const textures = this.map.createLayer('Textures', allLayers);
    // this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(textures);

    const furniture = this.map.createLayer('Furniture', allLayers);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(furniture);

    const furniture2 = this.map.createLayer('Furniture2', allLayers);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(furniture2);

    const decorations = this.map.createLayer('Decorations', allLayers);
    // this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(decorations);

    // create base level
    this.createBaseLevel(0.5, 2.5);

    // In the scene that is going to sleep
    this.events.on('sleep', () => {
      // events: start, sleep, wake, shutdown
      if(this.name === "Kitchen 1"){
        setTimeout(() => this.readyToRefresh = true, 30000);
      }
    });

    // In the scene that is about to wake
    this.events.on('wake', () => {
      if(this.name === "Kitchen 1"){
        if(this.readyToRefresh){
          this.removeItems();
          this.addObjects("Items");
          this.readyToRefresh = false;
        }
      }
    });
  }
}
